import { Box, SxProps, Theme, Typography } from '@mui/material';

import { appColors } from '../assets/appColors';

type BackrsHeaderCardProps = Readonly<{
  title: string;
}>;

export const BackrsHeaderCard = ({ title }: BackrsHeaderCardProps) => {
  return (
    <Box sx={headerCardStyle}>
      <Typography variant="h5" align="center" fontWeight={700}>
        {title}
      </Typography>
    </Box>
  );
};

const headerCardStyle: SxProps<Theme> = {
  backgroundColor: appColors.color.blue1,
  color: appColors.neutral.white,
  borderRadius: 2,
  border: `1px solid ${appColors.neutral.black}`,
  // we don't hardcode a width/height here to let the consumer of this component decide. See story for example
  width: '100%',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
};
